<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <div class="t-apply">来自 <b>{{ player_data.nickName }}</b>的邀请</div>

                    <div class="msg-view">
                        <div class="text">
                            <p><b>【{{ player_data.nickName }}】</b>邀请您进行助力，</p>
                            <p>每个ID上限助力3位好友！</p>
                        </div>
                    </div>            

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>
                    
                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
@include responseTo("desktop"){
    .apply-modal{
        transform: scale(0.8);
    }

}

.apply-modal{
    // position: relative;
    // width: 656px;
    // height: 337px;
    // background-image: url(~@/assets/images/modal/bg-modal-sm.png);     
}

.t-apply{
    font-size: 28px;
    color: #49392e;
    font-weight: 700;
    text-align: center;  
}

.msg-view{
    text-align: center;
    margin: 0 auto 0;
    padding: 40px 24px 0;
    line-height: 1.6;
    color: #3b3f3e;

    font-size: 22px;

    b{
        padding: 0 10px;
        color: #3b3f3e;
    }    
}

.notice{
    margin-top: 22px;
    text-align: center;
    color: #e4574a;
}

.warn{
    font-size: 22px;
    text-align: center;
    color: #de482b;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
    padding: 0 20px;
}

.u-btn.ok{
    width: 205px;
    height: 55px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 205px;
    height: 55px;
    margin: 0 10px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}
</style>

<script>
import { apiShareApply , apiInviteInfo } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码
            score : 0,
            success : false,
            reward_list : [
                {"giftId":"OW78","giftName":"闪光灯","sendNum":"300"},
                {"giftId":"E559","giftName":"十万个人士兵","sendNum":"2"},
                {"giftId":"ON02","giftName":"高级防具珍材包","sendNum":"100"}
            ],
            msg : {
                1009 : '该玩家已有3位好友助力',
            }             
        }
    },
    mounted(){
        this.render();
    },
    created (){
        document.body.style.overflow = 'hidden';
        this.$disableScroll();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$enableScroll();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },    
        render() {
            var _this = this;
            apiInviteInfo({code : this.code}).then(
                res => {
                    this.player_data = res.data;
                },
                rej => {
                    this.error_text = rej.message || '请稍后再试';
                    this.$toast(rej.message);
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                    this.destroyElement();                     
                },
            );
        },        
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            apiShareApply({ code : this.code }).then(
                res => {
                    this.$msg_modal({ type : 'apply-success' , text :  '助力成功，快去参加活动吧！' }); 
                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');
                    this.destroyElement();              
                },
                rej => {
                    this.destroyElement();

                    this.$store.commit("$_setCode", '');
                    localStorage.setItem('code', '');                       

                    this.$msg_modal({ type : 'bind-error' , text :  this.msg[rej.code] || rej.message}); 
                  
                },
            );
        },                
    },
}
</script>